import { FONTS, COLORS } from '../../constants';

const styles = () => ({
  root: {
    backgroundColor: COLORS.WHITE,
    padding: '20px 15px',
    fontFamily: FONTS.PRIMARY,
    color: COLORS.GREY_DARKER,
  },
  row1: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  row1Left: {
    display: 'flex',
    alignItems: 'center',
  },
  row1Right: {
    display: 'flex',
    alignItems: 'center',
  },
  jobId: {
    margin: 0,
    color: COLORS.GREEN,
    fontSize: '1rem',

    '& button': {
      fontFamily: FONTS.SECONDARY,
      fontWeight: 700,
      paddingBottom: 0,
    },
  },
  bullet: {
    color: COLORS.BLUE,
    fontSize: 30,
    lineHeight: '1rem',
    marginRight: 2,
  },
  status: {
    marginRight: 10,
  },
  status1: {
    color: COLORS.BLUE_LIGHT,
  },
  status2: {
    color: COLORS.YELLOW_DARK,
  },
  status3: {
    color: COLORS.GREEN,
  },
  dateCreated: {
    fontSize: '0.75rem',
    paddingLeft: 21,
  },
  row3: {
    marginTop: 10,
  },
  row4: {
    marginTop: 10,
    display: 'flex',
    flexWrap: 'wrap',
  },
  row5: {
    marginTop: 5,
  },
  customerName: {
    display: 'flex',
    alignItems: 'center',
  },
  customerInfoText: {
    fontSize: '0.75rem',
    marginLeft: 8,
    fontWeight: 500,
  },
  customerPhone: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 10,
  },
  customerEmail: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: 20,
    marginBottom: 10,
  },
  phoneIcon: {
    height: 14,
    width: 14,
  },
  phoneLink: {
    color: COLORS.BLUE_DARK,
    fontWeight: 'bold',
    textDecoration: 'none',
  },
});

export default styles;
